// AUTO-GENERATED from prompts/memory-schema.yaml.
// CLAUDE.md §1 — single source of truth for memory kinds + recall.

export const MEMORY_SCHEMA_VERSION = "0.3.0";

export type MemoryKindId = "Preference" | "Decision" | "Approval" | "Constraint" | "Fact" | "Concern";

export interface MemoryKindDef { id: MemoryKindId; label: string; description: string; decay_half_life_days: number; recall_weight: number; }

export const MEMORY_KINDS: readonly MemoryKindDef[] = [
  {
    "id": "Preference",
    "label": "Client preference",
    "description": "Soft preferences the client expressed (warm tones, no chrome, …).",
    "decay_half_life_days": 60,
    "recall_weight": 0.8
  },
  {
    "id": "Decision",
    "label": "Locked decision",
    "description": "A choice the client signed off (linen oak headboard, marble top, …).",
    "decay_half_life_days": 240,
    "recall_weight": 1
  },
  {
    "id": "Approval",
    "label": "Approval / sign-off",
    "description": "A milestone approval (render approved, BOQ frozen, …).",
    "decay_half_life_days": 540,
    "recall_weight": 0.95
  },
  {
    "id": "Constraint",
    "label": "Hard constraint",
    "description": "A non-negotiable (move-in date, budget cap, accessibility need).",
    "decay_half_life_days": 730,
    "recall_weight": 1
  },
  {
    "id": "Fact",
    "label": "Project fact",
    "description": "Verified objective facts (area, address, occupants).",
    "decay_half_life_days": 365,
    "recall_weight": 0.9
  },
  {
    "id": "Concern",
    "label": "Concern / flag",
    "description": "An open worry the client raised that we haven't resolved yet.",
    "decay_half_life_days": 30,
    "recall_weight": 0.85
  }
];

export const RECALL_WEIGHTS = {
  "semantic": 0.55,
  "temporal": 0.15,
  "kind": 0.2,
  "recency": 0.1
} as const;

export const RECALL_FLOOR_COSINE = 0.3;

export const RECALL_TOP_K_DEFAULT = 6;

export const MEMORY_ONTOLOGY = {
  "user": "foaf:Person",
  "session": "prov:Activity",
  "record": "hgm:MemoryRecord",
  "has_record": "hgm:hasMemoryRecord",
  "in_session": "hgm:inSession",
  "for_project": "hgm:forProject",
  "has_kind": "hgm:hasKind",
  "valid_from": "prov:startedAtTime",
  "valid_to": "prov:endedAtTime",
  "embedding": "hgm:embedding"
} as const;
